import { useState, useEffect } from 'react';
import {
  Modal,
  ModalContent,
  ModalOverlay,
  ModalFooter,
  ModalBody,
  Button,
  VStack,
  Text,
  FormLabel,
  FormControl,
  FormErrorMessage,
  Input,
  Divider,
  Icon,
  HStack,
  StackDivider,
} from '@chakra-ui/react';

import { IoMailOutline } from 'react-icons/io5';

import { useNavigate } from 'react-router-dom';

import groupHostInfoAtom from '~/recoil/atom/groupHostInfo';
import memberInfoAtom from '~/recoil/atom/memberInfo';
import { useRecoilValue, useRecoilState } from 'recoil';

import { v4 as uuidV4 } from 'uuid';

import * as fp from 'lodash/fp';

type MemberInfoModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (id: string, name: string) => void;
};

export default function MemberInfoModal({ isOpen, onClose, onConfirm }: MemberInfoModalProps) {
  const navigate = useNavigate();

  const groupHostInfo = useRecoilValue(groupHostInfoAtom);
  const [memberInfo, setMemberInfo] = useRecoilState(memberInfoAtom);

  const [memberNameInput, setMemberNameInput] = useState<{ value: string; error: string }>({
    value: memberInfo.name,
    error: '',
  });

  useEffect(() => {
    setMemberNameInput(fp.set('value', memberInfo.name));
  }, [memberInfo.name]);

  const handleSubmit = () => {
    if (fp.lt(memberNameInput.value.length, 2)) {
      setMemberNameInput(fp.set('error', '請輸入超過1個字的聯絡名稱'));
      return;
    }

    localStorage.setItem('memberName', memberNameInput.value);

    const memberId = (() => {
      if (memberInfo.id) {
        return memberInfo.id;
      }

      const newId = uuidV4();
      localStorage.setItem('memberId', newId);

      return newId;
    })();

    onConfirm(memberId, memberNameInput.value);
  };

  return (
    <Modal size="sm" isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalBody py={4}>
          <VStack align="stretch">
            <Icon
              alignSelf="center"
              as={IoMailOutline}
              borderRadius="full"
              bgColor="#FFF9EF"
              color="secondary"
              boxSize="3rem"
              p={2}
            />
            <Text fontSize="md" fontWeight="bold" textAlign="center">
              歡迎來到VO2蔬氧點餐網站
            </Text>
            <Text fontSize="md" textAlign="center">
              {groupHostInfo.name}邀請您揪團點餐
            </Text>

            <Divider />

            <Text fontSize="xs" fontWeight="bold">
              團長的話
            </Text>
            <Text py={1} px={2} fontSize="xs" bgColor="gray.200" borderRadius="4px">
              {groupHostInfo.note}
            </Text>

            <FormControl isRequired isInvalid={!!memberNameInput.error}>
              <FormLabel fontSize="xs">輸入您的揪團暱稱</FormLabel>
              <Input
                value={memberNameInput.value}
                onChange={(e) => setMemberNameInput(fp.set('value', e.target.value))}
              />
              <FormErrorMessage>{memberNameInput.error}</FormErrorMessage>
            </FormControl>
          </VStack>
        </ModalBody>
        <ModalFooter p={0} borderTopWidth="1px" borderColor="gray.200">
          <HStack w="full" spacing={0} divider={<StackDivider />}>
            <Button
              isFullWidth
              variant="unstyled"
              fontWeight="normal"
              onClick={() => {
                onClose();
                navigate('/');
              }}
            >
              不參加
            </Button>
            <Button isFullWidth variant="unstyled" fontWeight="normal" onClick={handleSubmit}>
              參加揪團
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
